import { Component, ContentChild, EventEmitter, Input, OnInit, Optional, Output, Self, TemplateRef, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { IonDatetime, IonModal } from '@ionic/angular/standalone';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'fv-datetimefield',
  templateUrl: './datetimefield.component.html',
  styleUrls: ['./datetimefield.component.scss'],
  imports: [
    IonicComponentsModule
  ],
  standalone: true,
})
export class DatetimefieldComponent implements ControlValueAccessor {

  //#region Propiedades

  @ViewChild(IonModal) public modal: IonModal
  @ViewChild(IonDatetime) public dateTimePicker: IonDatetime
  @ContentChild("selectorTpl") public selectorTpl: TemplateRef<any>
  @Input("label") public label: string
  @Input("readonly") public readonly: boolean
  @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano.

  private _value: string
  public get value(): string {
    return this._value
  }
  @Input("value") public set value(val: string) {
    this._value = val
  }
  @Output("valueChange") public valueChange = new EventEmitter<string>()
  @Output("valueSelected") public valueSelected = new EventEmitter<string>()

  public dateValue: string
  public dentroDeDiezAnos: number = new Date().getFullYear() + 10

  //#endregion

  //#region Constructor

  constructor(
    private util: UtilService,
    @Self() @Optional() private control: NgControl
  ) { 
    this.control.valueAccessor = this
  }

  //#endregion

  //#region Eventos

  public contentClick() {
    if (!this.readonly) {
      this.dateTimePicker.value = this.util.DateToISO8601(this.util.StringToDateTime(this.value))
      this.modal.isOpen = true
    }
  }

  public dateChanged(dateISO8601: string | string[]) {
    let date: Date
    if (dateISO8601 == null) {
      date = null
    } else {
      date = new Date(dateISO8601 as string)
    }
    this.value = this.util.DateTimeToString(date)
    this.valueChange.emit(this.value)
    this.valueSelected.emit(this.value)
    this.onChange(this.value)

    this.modal.isOpen = false
    this.onTouched()
  }

  //#endregion

  //#region Reactive Forms

  private onChange = (value: string) => {}
  private onTouched = () => {}

  writeValue(value: string): void {
    this.value = value
    this.valueChange.emit(value)
    this.onChange(value)
  }

  registerOnChange(fn: (value: string) => {}): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  public isInvalid(): boolean {
    return this.control ? this.control.invalid : false
  }

  public isTouched(): boolean {
    return this.control ? this.control.touched : false
  }

  //#endregion

}
